/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated';
import { createParenthesisNode } from '../../factoriesAny.js';
export var ParenthesisNodeDependencies = {
  NodeDependencies: NodeDependencies,
  createParenthesisNode: createParenthesisNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesParenthesisNode.generated.js
// module id = 182
// module chunks = 0